import { useState, useEffect } from "react";
import { GRAPHQL_ENDPOINT } from "src/constants/endpoints";
import { VALIDATE_PROMOTION_CODE } from "src/constants/queries";
import { useAuth } from "src/contexts/auth-provider";
import { useAxiosInterceptor } from "src/hooks/useAxiosInterceptor";
import { CustomerOrder } from "src/interfaces/order.interface";

export const useDiscount = (customerOrder: CustomerOrder) => {
  const [promoCode, setPromoCode] = useState("");
  const [discountAmountCents, setDiscountAmountCents] = useState(0);
  const [validationMessage, setValidationMessage] = useState("");
  const [isValidationError, setIsValidationError] = useState(false);
  const [appliedPromotionCode, setAppliedPromotionCode] = useState("");
  const [isDiscountLoading, setIsDiscountLoading] = useState(false);

  const { hasRestaurant } = useAuth();
  const { axBe } = useAxiosInterceptor();

  const validatePromotionCode = async () => {
    setIsDiscountLoading(true);
    try {
      const { data } = await axBe.post(GRAPHQL_ENDPOINT, {
        query: VALIDATE_PROMOTION_CODE,
        variables: {
          input: {
            storeCorrelationId: hasRestaurant?.correlationId,
            code: promoCode,
            orderType: customerOrder?.orderType,
            subtotalCents: customerOrder?.subtotalCents || 0,
            userCorrelationId: customerOrder?.customerCorrelationId,
            customerEmail: customerOrder?.customerEmail,
          },
        },
      });
      const result = data?.data?.validatePromotionCode;
      if (!result?.valid) {
        setDiscountAmountCents(0);
        setValidationMessage(result?.message || "Promotion is not valid.");
        setAppliedPromotionCode("");
        setIsValidationError(true);
        return;
      }
      setDiscountAmountCents(result?.discountAmountCents || 0);
      setAppliedPromotionCode(result?.promotionCode || promoCode);
      setValidationMessage(result?.message || "Promotion applied.");
      setIsValidationError(false);
    } catch (error) {
      setDiscountAmountCents(0);
      setValidationMessage("Unable to validate promotion code.");
      setAppliedPromotionCode("");
      setIsValidationError(true);
    } finally {
      setIsDiscountLoading(false);
    }
  };

  useEffect(() => {
    if (discountAmountCents) {
      setPromoCode("");
    }
  }, [discountAmountCents]);

  return {
    promoCode,
    setPromoCode,
    discountAmountCents,
    validatePromotionCode,
    isDiscountLoading,
    validationMessage,
    isValidationError,
    appliedPromotionCode,
  };
};
